module.exports = __webpack_public_path__ + "img/img4.251ebfd2.jpg";